module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/176ab990f78c97e4592a10ddf1cf04dd.png";